module.exports = __webpack_public_path__ + "img/kransekage.f61fb22e.jpg";